@if (station) {
  <div class="empty-station-item"
    [ngClass]="{'disabled':station.stationUsage.suspended || station.stationUsage.disabled, 'selected': selected}">
    <sc-flex fitHeight [centered]="true" vertical>
      <div>
        <sc-flex >
          <div class="icon">
            @if (station.stationUsage.suspended) {
              <sc-icon iconClass="fa-lock fa-2x"></sc-icon>
            }
            @if (station.stationUsage.disabled) {
              <sc-icon iconClass="fa-xmark fa-3x"></sc-icon>
            }
          </div>
          <sc-content-spacer></sc-content-spacer>
          <div class="title">
            {{station.name}}
          </div>
        </sc-flex>
      </div>
      <sc-content-spacer vertical [half]="true"></sc-content-spacer>
      @if (station.stationUsage.suspended) {
        <div>{{station.stationUsage.note}}</div>
      }
      @if (station.stationUsage.loadingZoneLock) {
        <div>
          <sc-dictionary-label dictionaryKey="tmc-yard.ui.control.sac-client.transport-details-list-entry.action.create-movement-order"></sc-dictionary-label>
        </div>
      }
    </sc-flex>
  </div>
}
